import SectionShell from "./SectionShell";

export default SectionShell;